/**
 * Was die Phase unter der Uhr und in der Bildmitte zeigt.
 *
 * Produktentscheidung vom 11.10.2026: Die Kampfphasen ("Early Game",
 * "Mid Game I" ...) stehen nicht mehr unter der Uhr - sie sagen im Gefecht
 * nichts, was man braucht, und nahmen dem Frontbalken den Platz direkt an
 * der Uhr. Was bleibt:
 *
 *   - die Vorbereitung mit ihren Sekunden, klein unter dem Frontbalken,
 *   - der Countdown 3 - 2 - 1 gross in der Bildmitte,
 *   - danach kurz der Startruf, ebenfalls in der Mitte.
 *
 * Auch "Overtime" steht nicht mehr da (Produktentscheidung vom selben Tag).
 *
 * Reine Funktion ohne React, damit sie ohne Bild pruefbar ist.
 */

import { isBattlePhase } from '@dueline/game-rules';
import type { MatchPhase } from '@dueline/shared';

/** So lange steht der Startruf nach dem Countdown in der Bildmitte. */
export const STARTRUF_SEKUNDEN = 2;

export interface PhasenAnzeige {
  /** Kleine Zeile unter dem Frontbalken - oder nichts. */
  zeile: string | null;
  /** Grosse Anzeige in der Bildmitte - oder nichts. */
  mitte: string | null;
}

export function phasenAnzeige(
  phase: string,
  sekundenUebrig: number,
  matchSekunden: number,
  texte: { phase: Record<string, string>; startCall: string },
): PhasenAnzeige {
  const name = texte.phase[phase] ?? phase;
  const rest = Math.ceil(sekundenUebrig);

  if (phase === 'countdown') {
    return { zeile: null, mitte: String(Math.max(1, rest)) };
  }

  if (isBattlePhase(phase as MatchPhase)) {
    // Die Matchuhr beginnt mit dem Startschuss bei null.
    return { zeile: null, mitte: matchSekunden < STARTRUF_SEKUNDEN ? texte.startCall : null };
  }

  // Vorbereitung, Warten, Ende: wie bisher, mit Restzeit, solange eine laeuft.
  return { zeile: sekundenUebrig > 0 ? `${name} ${rest}s` : name, mitte: null };
}
